import { Box, Stack, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { stageLabel } from "../../utils/stages";
import { v } from "../../utils/helpers";

export default function PartnerDirectoryDetails({ data }) {
  const { t } = useTranslation("freigabe");
  return <Box component="section" sx={{ minWidth: 0 }}>
    <Typography component="h3" variant="subtitle2">{t("promotion.partners")}</Typography>
    <Typography variant="body2" sx={{ color: v("text-2"), mb: 1 }}>{t("stageBranches.pd.intro")}</Typography>
    {!data ? <Typography variant="body2">{t("stageBranches.pd.unknown")}</Typography>
      : !data.entries.length ? <Typography variant="body2">{t("stageBranches.pd.empty")}</Typography>
      : <TableContainer sx={{ border: `1px solid ${v("border")}`, borderRadius: 1 }}>
        <Table size="small" aria-label={t("promotion.partners")} sx={{ tableLayout: "fixed", "& th, & td": { overflowWrap: "anywhere", verticalAlign: "top" } }}>
          <TableHead><TableRow><TableCell>{t("stageBranches.pd.pid")}</TableCell><TableCell>{t("stageBranches.pd.destinations")}</TableCell></TableRow></TableHead>
          <TableBody>{data.entries.map(entry => <TableRow key={entry.pid}>
            <TableCell component="th" scope="row">{entry.pid}</TableCell>
            <TableCell><Stack spacing={0.5}>{entry.destinations.map(destination => <Typography variant="body2" key={`${destination.stage}:${destination.targetId || "default"}`}>
              {stageLabel(destination.stage)}{destination.targetName ? ` (${destination.targetName})` : ""}: {t(destination.selected === null ? "stageBranches.pd.unknown" : destination.selected ? "stageBranches.pd.yes" : "stageBranches.pd.no")}
            </Typography>)}</Stack></TableCell>
          </TableRow>)}</TableBody>
        </Table>
      </TableContainer>}
  </Box>;
}
